import styled from "styled-components";
import { Label } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { useModalDurationPicker } from "~/client/hooks";
import { useInit } from "../logic";
import Fields from "./fields";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    flex: 1;
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
  }
`;

const Content = styled.div`
  & {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: calc(${(props) => props.theme.sizes.edge} * 0.5);
    width: 100%;
    & > * {
      grid-column: span 1;
      width: auto;
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    ${Content} {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  ${(props) => props.theme.medias.maxSM} {
    ${Content} {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

function Form() {
  const { data } = useModalDurationPicker();
  const { t } = useT();

  useInit(data.milliseconds);

  return (
    <Wrapper>
      <Label value={t("structs.customDuration")} />
      <Content>
        <Fields.Years />
        <Fields.Days />
        <Fields.Hours />
      </Content>
    </Wrapper>
  );
}

export default Form;
